import Breadcrumb from "components/Breadcrumb/Breadcrumb";
import SwitchOptionTable from "components/OptionsTable/SwitchOptionTable";
import React, { useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { TerminalColumns } from "./view/Column";
import SearchForm from "./view/SearchForm";
import TerminalHistory from "./components/terminal-history/terminal-history";
import TerminalActionForm from "./view/TerminalActionForm";
import { hasPermission } from "utils/HasPermission";
import { MdHistory, MdOutlineDisabledByDefault } from "react-icons/md";
import { addEditDataAPI } from "services/CRUDServices";
import NewStaticTable from "components/staticTable/NewStaticTable";
import { toast } from "react-toastify";
import { filterTerminal } from "redux/define-terminal";
import { paginationType } from "global/Interfaces/Interfaces";
import { BiCheckSquare } from "react-icons/bi";
const DefineTerminal: React.FC = (): JSX.Element => {
  const [isActive, setIsACtive] = useState(true);

  const { defineTerminal, fetchpost, filter } = useSelector(
    (state: any) => state.defineTerminal
  );
  const { pageNumbers } = useSelector(
    (state: paginationType) => state.paginate
  );
  const [currentData, setCurrentData] = useState();
  const [actionModal, setActionModal] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [terminalId, setTerminalId] = useState();
  const [selectedRow, setSelectedRow] = useState<any>([]);
  const dispatch = useDispatch();
  const refreshTable = () => {
    dispatch(
      filterTerminal({
        ...filter,
        pageSize: 10,
        pageNumber: pageNumbers,
      }) as any
    );
  };

  async function terminalAction(isActive: boolean) {
    try {
      const selectedIds = selectedRow.map((item: any) => item.terminalNo);
      const url = isActive
        ? "/core-api/terminals/v1/s0/bulkActivate"
        : "/core-api/terminals/v1/s0/bulkDeActivate";
      await addEditDataAPI(url, "put", selectedIds);
      toast.success("عملیات با موفقیت انجام شد");
      setSelectedRow([]);
      refreshTable();
    } catch {}
  }

  const data =
    defineTerminal?.response?.items?.length !== 0
      ? defineTerminal?.response?.items?.map((item: any) => {
          return {
            ...item,
            selectHub: item.selectHub?.text || "",
            isActive: isActive ? "فعال" : "غیر فعال",
            selectEmployee: item.selectEmployee?.text,
            operation: (
              <div className="flex w-full gap-3 justify-center">
                {hasPermission("TERMINAL_HUB_PERSONNEL_ASSIGNMENT_HISTORY") && (
                  <button
                    className=" border-none	 text-[14px]  w-[20px] h-[20px] "
                    onClick={() => {
                      setTerminalId(item.id);
                      setHistoryModal(!historyModal);
                    }}
                  >
                    <MdHistory className="w-full h-full" />
                  </button>
                )}
                {hasPermission("editTerminal") && (
                  <button
                    className=" border-none	 text-[14px]  w-[20px] h-[20px] "
                    onClick={() => {
                      setCurrentData(item);
                      setActionModal(!actionModal);
                    }}
                  >
                    <AiOutlineEdit className="w-full h-full" />
                  </button>
                )}

                {/* <DeleteOperation
                  itemId={item.id}
                  title={"حذف ترمینال"}
                  handleDeleteActionNewData={refreshTable}
                  route={deleteUrls.dock}
                /> */}
              </div>
            ),
          };
        })
      : [];

  return (
    <div>
      <Breadcrumb beforePage="مدیریت اطلاعات پایه" curentPage="تعریف ترمینال" />
      <SearchForm isActive={isActive} />
      <SwitchOptionTable
        accessPage={[
          {
            code: "A24",
            value: () => setActionModal((prev) => !prev),
            permission: hasPermission("createTerminal"),
          },
          {
            code: "A1",
            value: { data: data, columns: TerminalColumns, title: "terminal" },
          },
          {
            code: "A3",
            value: { data: isActive, action: () => setIsACtive(!isActive) },
          },
          {
            code: "A80",
            value: {
              text: "غیر فعال کردن ترمینالها",
              customClick: async () => {
                terminalAction(false);
              },
              icon: <MdOutlineDisabledByDefault size={18} />,
              // loading: isLoading,
            },
            permission: hasPermission("TERMINAL_BULK_DEACTIVATION"),
          },
          // {
          //   code: "A80",
          //   value: {
          //     text: " فعال کردن ترمینالها",
          //     customClick: async () => {
          //       terminalAction(true);
          //     },
          //     icon: <BiCheckSquare size={18} />,
          //     // loading: isLoading,
          //   },
          //   permission: hasPermission("TERMINAL_BULK_ACTIVATION"),
          // },
        ]}
      />

      <NewStaticTable
        data={data ? data : []}
        THWrapper={"whitespace-nowrap"}
        selectAble={true}
        pagination={defineTerminal?.response?.totalItems}
        setselectedState={setSelectedRow}
        selectedState={selectedRow}
        column={TerminalColumns}
        ignoreRedux={true}
        loading={fetchpost}
      />

      <TerminalActionForm
        open={actionModal}
        setOpen={setActionModal}
        currentData={currentData}
        setCurrentData={setCurrentData}
      />
      <TerminalHistory
        open={historyModal}
        setOpen={setHistoryModal}
        terminalId={terminalId}
      />
    </div>
  );
};

export default DefineTerminal;
